import { UserAction } from "@brookbush/types";

import { getCookie } from "cookies-next";
import posthog from "posthog-js";

/**
 * Builds the standard Clerk `unsafeMetadata` object attached at sign-up, sourced
 * from tracking cookies and the current PostHog session. Mirrors the inline
 * objects used by SignUpModal and the sign-up page so signup analytics stay
 * consistent when signing up from the onboarding wizard.
 *
 * @param {string} signUpPath - The path the user signed up from
 * @returns {Record<string, unknown>} Clerk unsafeMetadata fields
 */
const getSignupUnsafeMetadata = (
	signUpPath: string,
): Record<string, unknown> => ({
	ctaClick: getCookie(`${UserAction.SIGN_UP}:cta-click`),
	signUpPath,
	isTrialUser: !!getCookie("is-trial-user") || !!getCookie("referrer-id"),
	ipAddress: getCookie("ip-address"),
	userAgent: getCookie("user-agent"),
	auditedCourseId: getCookie("audited-course-id"),
	auditedVideoId: getCookie("audited-video-id"),
	auditedGlossaryTermId: getCookie("audited-glossary-term-id"),
	referrerId: getCookie("referrer-id"),
	shouldReceiveGiftCard: getCookie("utm-gift-card"),
	posthogSessionId: posthog.get_session_id(),
});

export default getSignupUnsafeMetadata;
